/**
 * We need this polyfill in order to generate uuids.
 *
 * The uuid package depends on crypto.getRandomValues
 * https://github.com/uuidjs/uuid#getrandomvalues-not-supported
 *
 * ...but the crypto-browserify package that we're using does not include this method:
 * https://github.com/browserify/crypto-browserify
 */
export const polyfillGetRandomValuesIfNecessary = () => {
    /**
     * TODO: I tried calling this immediately without the wrapper function, but it was causing
     * 'crypto is not defined' errors when the module is loaded. For some reason, the
     * crypto polyfill seems to be loaded _after_ this module so we have to do this lazily.
     */
    if (typeof crypto.getRandomValues === "undefined") {
        Object.defineProperty(crypto, "getRandomValues", {
            // @ts-ignore
            value: (arr: string | never[]) => crypto.randomBytes(arr.length)
        });
    }
};
